import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { featuresArticle } from '@/mocks/articleData';

export default function FeaturesArticle() {
  return (
    <>
      <Navbar />
      <ArticleTemplate article={featuresArticle} />
      <Footer />
    </>
  );
}